import { reservePosthogPersonPropertiesSync } from './posthogEvents';

export function isPosthogUsingDistinctId(posthog, distinctId) {
  if (!posthog || !distinctId) return false;

  const currentDistinctId = typeof posthog.get_distinct_id === 'function' ? posthog.get_distinct_id() : null;

  return currentDistinctId === distinctId;
}

export function syncPosthogIdentity(posthog, distinctId, personProperties = {}) {
  if (!posthog || !distinctId) return false;

  const isUsingDistinctId = isPosthogUsingDistinctId(posthog, distinctId);
  const shouldSyncPersonProperties =
    typeof posthog.setPersonProperties === 'function' && reservePosthogPersonPropertiesSync(distinctId, personProperties);

  if (!isUsingDistinctId) {
    posthog.identify(distinctId);
  }

  if (shouldSyncPersonProperties && typeof posthog.setPersonProperties === 'function') {
    posthog.setPersonProperties(personProperties);
  } else {
    posthog.setPersonPropertiesForFlags?.(personProperties, false);
  }

  return !isUsingDistinctId;
}
